import { render, staticRenderFns } from "./FormControlPagesNavigation.vue?vue&type=template&id=4a9c88ae"
import script from "./FormControlPagesNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesNavigation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports